// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('LabelDuplicateVO')
export class LabelDuplicateVO {
  @JsonProperty('articleNumber', 'string')
  public articleNumber: string = undefined;

  @JsonProperty('productionPlant', 'string')
  public productionPlant: string = undefined;
}
